/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostVideoCompleteMultiPartUploadRequestPartsInner
 */
export interface PostVideoCompleteMultiPartUploadRequestPartsInner {
    /**
     * 
     * @type {number}
     * @memberof PostVideoCompleteMultiPartUploadRequestPartsInner
     */
    partNumber: number;
    /**
     * 
     * @type {string}
     * @memberof PostVideoCompleteMultiPartUploadRequestPartsInner
     */
    eTag: string;
}

/**
 * Check if a given object implements the PostVideoCompleteMultiPartUploadRequestPartsInner interface.
 */
export function instanceOfPostVideoCompleteMultiPartUploadRequestPartsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partNumber" in value;
    isInstance = isInstance && "eTag" in value;

    return isInstance;
}

export function PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSON(json: any): PostVideoCompleteMultiPartUploadRequestPartsInner {
    return PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped(json, false);
}

export function PostVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostVideoCompleteMultiPartUploadRequestPartsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partNumber': json['partNumber'],
        'eTag': json['eTag'],
    };
}

export function PostVideoCompleteMultiPartUploadRequestPartsInnerToJSON(value?: PostVideoCompleteMultiPartUploadRequestPartsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partNumber': value.partNumber,
        'eTag': value.eTag,
    };
}

